import {
  BuildingType,
  BuildingTypeCreateCommand,
  BuildingTypeCreatedEvent,
  BuildingTypeDeleteCommand,
  BuildingTypeDeletedEvent,
  BuildingTypeId,
  BuildingTypePageQuery,
  BuildingTypeUpdateCommand,
  BuildingTypeUpdatedEvent
} from "../model/BuildingType";
import {config} from "../../../config";
import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {firstPage, PageQuery, PageResult, toPagination} from "@tracabois/utils";
import {useState} from "react";
import {authQuery} from "../../../utils/authQuery";

export const BuildingTypeApi = createApi({
  reducerPath: 'buildingTypeApi',
  baseQuery: authQuery({baseUrl: config.baseUrl}),
  tagTypes: ['BuildingType'],
  endpoints: (builder) => ({
    getBuildingTypeById: builder.query<BuildingType, BuildingTypeId>({
      query: (id: BuildingTypeId) => ({
        url: `buildingTypeGet`,
        method: 'POST',
        body: {id: id}
      }),
    }),
    buildingTypePage: builder.query<PageResult<BuildingType>, BuildingTypePageQuery>({
      query: (page: BuildingTypePageQuery) => ({
        url: `buildingTypePage`,
        method: 'POST',
        body: page
      }),
      transformResponse: (response: PageResult<BuildingType>[]) => response[0],
      providesTags: ['BuildingType'],
    }),
    buildingTypeCreate: builder.mutation<BuildingTypeCreatedEvent, BuildingTypeCreateCommand>({
      query: (cmd: BuildingTypeCreateCommand) => ({
        url: `buildingTypeCreate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: BuildingTypeCreatedEvent[]) => response[0],
      invalidatesTags: ['BuildingType'],
    }),
    buildingTypeUpdate: builder.mutation<BuildingTypeUpdatedEvent, BuildingTypeUpdateCommand>({
      query: (cmd: BuildingTypeUpdateCommand) => ({
        url: `buildingTypeUpdate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: BuildingTypeUpdatedEvent[]) => response[0],
      invalidatesTags: ['BuildingType'],
    }),
    buildingTypeDelete: builder.mutation<BuildingTypeDeletedEvent, BuildingTypeDeleteCommand>({
      query: (cmd: BuildingType) => ({
        url: `buildingTypeDelete`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: BuildingTypeDeletedEvent[]) => response[0],
      invalidatesTags: ['BuildingType'],
    }),
  }),
})

export const {
  useGetBuildingTypeByIdQuery, useBuildingTypePageQuery,
  useBuildingTypeCreateMutation, useBuildingTypeUpdateMutation, useBuildingTypeDeleteMutation
} = BuildingTypeApi


export const useBuildingTypeAllQuery = () => {
  const {data, error, isLoading, refetch} = BuildingTypeApi.useBuildingTypePageQuery({})
  const [pageQuery, setPageQuery] = useState<PageQuery>({
    pagination: firstPage
  })
  let sortedData =  [...data?.items ?? []]
  if(pageQuery.search) {
    sortedData = sortedData.filter((item) => {
      return item.name.toLowerCase().includes(pageQuery.search?.toLowerCase() ?? "")
    })
  }
  const page = toPagination(sortedData, pageQuery.pagination)

  return {data: page, error, isLoading, refetch, setPageQuery}
}
